module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/header_sp_f0ecb785a834e4dbf4e45fdea2540a9d.jpg";